import client from "./client";

export const createStream = async (signalRequest: Promise<string>, sessionId: any) => {
  return client
    .post(`/stream/connect`, {signalRequest: await signalRequest, sessionId})
    .then(response => response.data.response);
};

export const getSignalResponse = async (sessionId: any) => {
  return client
    .post(`/stream/signal`, {sessionId})
    .then(response => response.data.response);
};
